<script>
  import { fade } from 'svelte/transition';

  export let show = false;
  export let className = '';
  export let duration = 300;
</script>

{#if show}
  <div transition:fade={{ duration }} class={className}>
    <slot />
  </div>
{/if}
